import React, { Component } from "react";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";

import TransactionHistoryView from "./NotificationActivityLogView";
import {
  getNotificationsActivityLogList,
  updateRowsPerPageOfActivityLog,
  updateCurrentPageOfActivityLog,
  //
} from "../../../../store/notificationManagement/notificationManagementActions";

class NotificationActivityLogContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPageOfActivityLog: this.props.currentPageOfActivityLog,
      rowsPerPageOfActivityLog: this.props.rowsPerPageOfActivityLog,
    };

    //
    this.handleTableRowsChange = this.handleTableRowsChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    //
    this.onClickNotificationTypeMenuFilterOptions =
      this.onClickNotificationTypeMenuFilterOptions.bind(this);
  }

  componentDidUpdate(prevProps, prevStates) {
    this.handleStateUpdateOnComponentUpdate(prevProps, prevStates);
  }

  handleStateUpdateOnComponentUpdate = (prevProps, prevStates) => {
    if (
      prevStates?.rowsPerPageOfActivityLog !==
      this.props?.rowsPerPageOfActivityLog
    ) {
      this.setState((prev) => {
        return {
          ...prev,
          rowsPerPageOfActivityLog: this.props.rowsPerPageOfActivityLog,
        };
      });
    }
    if (
      prevStates?.currentPageOfActivityLog !==
      this.props?.currentPageOfActivityLog
    ) {
      this.setState((prev) => {
        return {
          ...prev,
          currentPageOfActivityLog: this.props.currentPageOfActivityLog,
        };
      });
    }
  };

  componentDidMount() {
    //call fetch list api
    const { currentPageOfActivityLog, rowsPerPageOfActivityLog } = this.state;

    const notificationId = this.props.match.params.id;
    const data = {
      notificationId: notificationId,
    };

    this.fetchActivityLogsList();
  }

  componentWillUnmount() {
    this.handleResetReduxState();
  }

  handleResetReduxState = () => {
    const data = { label: "10", value: 10 };
    this.props?.updateRowsPerPageOfActivityLog(data);
    this.props?.updateCurrentPageOfActivityLog(1);
  };

  //--------------------page handling

  handleTableRowsChange = (value) => {
    this.setState(
      (prev) => ({
        ...prev,
        rowsPerPageOfActivityLog: value,
        currentPageOfActivityLog: 1,
      }),
      () => {
        const { currentPageOfActivityLog, rowsPerPageOfActivityLog } =
          this.state;
        this.fetchActivityLogsList();
      }
    );
  };

  handleChangePage = (page) => {
    this.setState(
      (prev) => ({ ...prev, currentPageOfActivityLog: page }),
      () => {
        this.fetchActivityLogsList();
      }
    );
  };

  updateReduxStateOfCurrentPageAndRowLimit = () => {
    // const currentPage = reset ? 1 : this.state?.currentPageOfActivityLog;
    // const rowsPerPage =
    //   reset && !preserveTheRows
    //     ? 10
    //     : this.state?.rowsPerPageOfActivityLog?.value;
    // const pageData = {
    //   currentPageOfActivityLog: currentPage,
    //   rowsPerPageOfActivityLog: rowsPerPage,
    // };
    // this.props.updateCurrentPageAndRowLimit(pageData); //update the redux state
  };

  //--------------------filter based on notification Type

  onClickNotificationTypeMenuFilterOptions = (value) => {
    // console.log("value", value);
    this.setState(
      (prev) => ({
        ...prev,
        searchValue: {
          ...prev?.searchValue,
          notificationType: value?.type || "",
        },
      }),
      () => {
        // call the fetch list api
        const { rowsPerPageOfActivityLog } = this.state;
        this.fetchActivityLogsList(1, rowsPerPageOfActivityLog?.value);
      }
    );
  };

  //--------------------api call

  fetchActivityLogsList = (
    page = this.state.currentPageOfActivityLog,
    limit = this.state.rowsPerPageOfActivityLog?.value
  ) => {
    const data = {
      notificationId: this.props.match?.params?.id,
    };
    this.props.getNotificationsActivityLogList(data, page, limit);
  };

  render() {
    const rowsPerPageDropDownOptions = [
      { label: "10", value: 10 },
      { label: "15", value: 15 },
      { label: "20", value: 20 },
      { label: "25", value: 25 },
      { label: "30", value: 30 },
    ];

    const { activityLogList } = this.props;
    const { currentPageOfActivityLog, rowsPerPageOfActivityLog } = this.state;

    return (
      <TransactionHistoryView
        //list
        activityLogList={activityLogList}
        notificationId={this.notificationId}
        //all states
        currentPageOfActivityLog={currentPageOfActivityLog}
        rowsPerPageOfActivityLog={rowsPerPageOfActivityLog}
        //select input options
        rowsPerPageDropDownOptions={rowsPerPageDropDownOptions}
        //handler functions
        handleTableRowsChange={this.handleTableRowsChange}
        handleChangePage={this.handleChangePage}
        //api call
        fetchActivityLogsList={this.fetchActivityLogsList}
      />
    );
  }
}

NotificationActivityLogContainer.propTypes = {};

const mapStateToProps = (state) => ({
  //list
  activityLogList: state.notificationManagement.activityLogList,
  //page state
  currentPageOfActivityLog:
    state.notificationManagement.currentPageOfActivityLog,
  rowsPerPageOfActivityLog:
    state.notificationManagement.rowsPerPageOfActivityLog,
});

export default connect(mapStateToProps, {
  //api
  getNotificationsActivityLogList,
  updateRowsPerPageOfActivityLog,
  updateCurrentPageOfActivityLog,
  //
})(NotificationActivityLogContainer);
